export default __webpack_public_path__ + "static/media/tn-evolution-logo-black.852c8fdb.svg";